import * as types from './index';

export const rolesListAction = (data) => {
    return {
    type: types.ROLES_LIST,
    data
    }
};

export const rolesAddAction = (data) => {
    return {
    type: types.ROLES_ADD,
    data
    }
};

export const rolesEditAction = (data) => { 
    return {
    type: types.ROLES_EDIT,
    data
    }
};

export const rolesUpdateAction = (data) => {
    return {
    type: types.ROLES_UPDATE,
    data
    }
};    

export const rolesDeleteAction = (data) => {
    return {
    type: types.ROLES_DELETE,
    data
    }
};

export const rolesPermissionEditAction = (data) => {
    return {
    type: types.ROLES_PERMISSION_EDIT,
    data
    }
};

export const rolesPermissionUpdateAction = (data) => {
    return {
    type: types.ROLES_PERMISSION_UPDATE,
    data
    }
};